import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import React from 'react';
import './style.scss';

interface IProps {
    value?: Moment;
    defaultValue?: Moment;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    showTime?: boolean;
    disabledDate?: (value: any) => void;
    height?: number;
    onOk?: (date: Moment) => void;
    format?: string;
    suffixIcon?: boolean;
    picker?: 'date' | 'month' | 'quarter' | 'year' | 'time';
    field?: any;
    onChange?: (value: any) => void;
}

const DatePickerWrap: React.FC<IProps> = ({
    onChange,
    placeholder,
    disabled,
    disabledDate,
    showTime,
    value,
    onOk,
    format,
    suffixIcon = false,
    defaultValue,
    picker = 'date',
    field,
}) => {
    const props = {
        disabled,
        disabledDate,
        showTime,
        placeholder,
        onChange,
        value,
        onOk,
        format,
        defaultValue,
        ...(!suffixIcon && { suffixIcon: null }),
    };

    return (
        <DatePicker
            className={`datepicker__wrap`}
            picker={picker}
            {...props}
            {...field}
            disabledDate={disabledDate}
            showTime={showTime}
            value={!moment(field.value).isValid() ? '' : field.value}
        />
    );
};

export default React.memo(DatePickerWrap);
